export default "__VITE_ASSET__d0c043b1__"